import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import apiService from '../services/api';
import { ServiceType } from '../services/api';
import type { UserResponseDto } from '../api-schema/generated/types';

const coreService = apiService.getService(ServiceType.CORE);

export const useMe = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState<UserResponseDto | null>(null);
    const [loading, setLoading] = useState(true);

    const fetchMe = useCallback(async () => {
        try {
            const token = localStorage.getItem('access_token');
            if (!token) {
                navigate('/signin');
                return;
            }

            const response = await coreService.get<UserResponseDto>('/users/me', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            setUser(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching user info:', error);
            message.error('Failed to load user info');
            setLoading(false);
        }
    }, [navigate]);

    useEffect(() => {
        fetchMe();
    }, [fetchMe]);

    return { user, loading, refetch: fetchMe };
};
